import { SET_DEVICE_INFO } from '../actions/deviceActions';
import { AUTH_LOGOUT, SWITCH_TEAMS } from '../actions/authActions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DEVICE_INFO: {
      const { deviceInfo } = action;
      return {
        ...deviceInfo,
      };
    }
    case AUTH_LOGOUT:
    case SWITCH_TEAMS: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};
